import { NavLink } from "@/project/karuna/components/NavLink";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarTrigger,
  useSidebar,
} from "@/project/karuna/components/ui/sidebar";
import { useKarunaLink } from "@/project/karuna/utils/navigationRoutes";
import { ADMIN_MENU_ITEMS } from "@/project/karuna/constants/adminPermissions";
import { useAdminPermissions } from "@/project/karuna/contexts/AdminPermissionsContext";

export function AdminSidebar() {
  const { open } = useSidebar();
  const getLink = useKarunaLink();
  const { hasPermission } = useAdminPermissions();

  const visibleItems = ADMIN_MENU_ITEMS.filter(item =>
    hasPermission(item.permission)
  );

  return (
    <Sidebar>
      <SidebarTrigger className="m-2 self-end" />

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Admin Portal</SidebarGroupLabel>

          <SidebarGroupContent>
            <SidebarMenu>
              {visibleItems.map(item => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <NavLink
                      to={getLink(item.url)}
                      end
                      className="hover:bg-muted/50"
                      activeClassName="bg-muted text-primary font-medium"
                    >
                      <item.icon className="mr-2 h-4 w-4" />
                      {open && <span>{item.title}</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
